module.exports = __webpack_public_path__ + "media/flags/en-c29f2b77.svg";